export default {
    星财宝专户: '星财宝专户',
    offline: {
        title: '星财宝专户已下线',
        message: '请更新至最新版本app后查看',
    },
    确定: '确定',
    lang: 'zhCn',
    请在方框内横向正楷签署你的名字: '请在<span style="color: #ff6907;">方框内</span>横向正楷签署你的名字：',
    前往认证: '前往认证',
    前往认证popText: '尊敬的客户，星财宝专户相关服务仅对专业投资者开放，根据监管要求，您需要提供800万港元资产的认证',
    查看进度: '查看进度',
    查看进度popText: '尊敬的客户，您已提交专业投资者认证申请，点击下方按钮查看申请进度',
    请勾选协议: '请勾选协议',
    agreement: {
        title: '【星财宝专户】服务由【复星国际资产管理有限公司】提供',
        本人已阅读并同意: '本人已阅读并同意',
        星财宝专户全权委托投资管理协议: '《星财宝专户全权委托投资管理协议》',
        及签署理财账户: '及签署理财账户',
        已确认: '已确认',
        去测评: '去测评',
        提示: '提示',
        '您尚未完成风险测评，无法开通星财宝专户相关服务，请尽快测评': '您尚未完成风险测评，无法开通星财宝专户相关服务，请尽快测评',
        '您的风险测评结果已过期，无法开通星财宝专户相关服务，请尽快重新测评': '您的风险测评结果已过期，无法开通星财宝专户相关服务，请尽快重新测评',
        重新测评: '重新测评',
        您当前的风险等级为: '您当前的风险等级为',
        riskServer: '，星财宝专户服务的风险等级与您的风险承受能力不匹配，无法开通相关服务',
        '您尚未开通理财账户，是否完成风险测评并开通？': '您尚未开通理财账户，是否完成风险测评并开通？',
        本人已阅读并同意签署: '本人已阅读并同意签署',
        客户协议书: '《客户协议书》',
        请设置交易密码: '为保障您的账号安全，请设置交易密码',
        前往设置: '前往设置',
        稳健型: '稳健型(1级别)',
        中度型: '中度型(2级别)',
        均衡型: '均衡型(3级别)',
        增长型: '增长型(4级别)',
        进取型: '进取型(5级别)',
    },
    riskDisclosure: {
        风险披露: '风险披露',
        请点击下方播放按钮听取完整风险披露音频: '请点击下方播放按钮听取完整风险披露音频',
        我已确认自愿签署: '我已确认自愿签署',
        xieyi: '《星财宝专户全权委托投资管理协议》',
        我已确认及同意使用和接收电子签名于: '我已确认及同意使用和接收电子签名于',
        我已确认及明白: '我已确认及明白【星财宝专户】服务所涉及的风险，包括固定收益工具风险、法律与政策风险、信息披露风险等',
        我已全权委托: '我已全权委托【复星国际资产管理有限公司】为我管理【星财宝专户】，该专户服务以现金管理为目的，专户的投资范围具体参见',
        载明的范围: '载明的范围',
        复星国际证券持牌代表: '复星国际证券持牌代表',
        资管持牌代表: '复星国际资管持牌代表',
        下一步: '下一步',
        ypjzz: '音频加载中',
        音频加载中: '音频加载中',
        图片加载中: '图片加载中',
        bs: '倍速',
        0: '普',
        1: '粵',
    },

    本人已阅读并同意签署:
        '本人已阅读并同意签署《星财宝专户全权委托投资管理协议》，其中包括《客户声明及确认》《附件A:费用表》《附件B-投资策略》《附件 C – 投资交易第三者指示授权／弥偿书》、《附件 D - (星财宝) 货币基金自动买入及赎回服务协议》',
    status: {
        联系客服: '联系客服',
        资料审核不通过: '资料审核不通过',
        重新签名: '重新签名',
        开通失败: '星财宝专户开通失败',
        重新申请: '重新申请',
        开通成功: '星财宝专户开通成功',
        账户号码: '星财宝专户号码',
        买入产品: '买入产品',
        资料审核中: '星财宝专户开户资料审核中',
        '预计1-2个工作日开通': '预计1-2个工作日开通',
        完成: '完成',
    },
    sendPage: {
        srdxyzm: '输入短信验证码',
        yfsdxyzmz: '已发送短信验证码至：',
        cxfs: '重新发送',
        sbdyzm: '收不到验证码',
        nkylxkfjxyzmcx: '您可以联系客服进行验证码查询。',
        dlkf: '内地客服：',
        xgkf: '香港客服：',
        qsrzqdyzmzsyc: '验证码错误或失效，请重新输入',
        zdl: '知道了',
        获取语音验证码: '获取语音验证码',
        '我们将通过电话语音告知您验证码，请留意接听。': '我们将通过电话语音告知您验证码，请留意接听。',
        '如仍无法收到，可': '如仍无法收到，可',
        联系客服: '联系客服',
        '语音验证码已发送，请留意接听电话': '语音验证码已发送，请留意接听电话',
        重新获取: '重新获取',
        输入语音验证码: '输入语音验证码',
        我们正在打电话至: '我们正在打电话至：',
        电话将提供验证码: '，电话将提供验证码',
        '语音验证码获取频率过高，请稍后再试': '语音验证码获取频率过高，请稍后再试',
        联系我们: '联系我们',
        repeatTips: '60s内无须重复获取验证码',
    },
    eSignInnerHtml: `<h1>关于使用电子签名的同意书</h1><h2>1)同意范围</h2><p>本人在此不可撤销地同意及授权复星国际证券有限公司（“贵公司”），就本人与贵公司进行之{userName}，使用电子签名方式以取代传统之亲笔书面签名。</p><h2>2)电子签名之定义及方法</h2><p>本同意书所指之“电子签名”，是依据香港法例第553章《电子交易条例》所界定之方式，为识别本人身份及表明本人认证或批准相关电子纪录之目的而所用之方法。该方法包括但不限于：</p><ul><li>a)在贵公司提供之应用程程（APP）内，通过预先验证之登录程序（如交易密码、一次性短信验证码）后，点击“确认”、“同意”或“签署”按钮；</li><li>b)贵公司认为可靠且适当之其他电子认证方式。</li></ul><h2>3)法律效力</h2><p>本人明确承认并同意，根据《电子交易条例》，以此方式产生之电子签名完全满足任何法律要求签名之规定，并与本人亲笔书写之签名具有同等之法律效力。本人承诺不会以签名仅为电子形式为由，质疑该等已签署文件之法律有效性、可执行性或其作为证据之效力。</p><h2>4)确认为本人操作</h2><p>本人明白，通过本人账户交易密码及验证后于APP进行之任何电子签署操作，均视为本人本人之行为，并由本人承担由此产生之一切法律后果。</p><h2>5)同意之持续性</h2><p>本同意持续有效，直至本人以书面形式通知贵公司终止此项同意为止。惟在该终止生效前已完成之电子签署行为，其法律效力不受影响。</p><h2>6)查阅与保存</h2><p>本人同意贵公司以电子纪录方式保存及管理以此方式签署之所有文件，并可应本人要求提供该等文件之副本。</p>`,
}
